<template>
  <div class="language-toggler">
    <div
        class="language-toggler__elem"
        :class="{ 'language-toggler__elem--active': $i18n.locale === 'ua'}"
        @click="clickToggler('ua')"
    >
      UA
    </div>

    <div class="language-toggler__divider" />

    <div
        class="language-toggler__elem"
        :class="{ 'language-toggler__elem--active': $i18n.locale === 'en'}"
        @click="clickToggler('en')"
    >
      EN
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';

export default {
  name: 'LanguageToggler',
  props: {},

  components: {},

  data() {
    return {}
  },

  mounted() {
  },

  created() {
  },

  updated() {
  },

  methods: {
    clickToggler(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
      if(locale === 'en') {
        this.$router.push('/?lang=en')
      } else {
        this.$router.push('/')
      }
    }
  },

  watch: {},

  computed: {
    ...mapState({})
  }
}
</script>

<style lang="scss" scoped>
</style>